import React, { Component } from 'react';
import Loading from '../Loading';
import { withTranslation } from 'react-i18next';

class Announcement extends Component {
    constructor(props) {
        super();
        this.buttonName = props.buttonName ?? 'Got It';
        this.onClose = this.onClose.bind(this);
        this.state = {
            isOpen: true,
        };
    }

    onClose() {
        this.setState({ isOpen: false });
    }

    render() {
        const { t } = this.props;
        const buttonName = this.props.buttonName ?? t('discover.announcement.buttonName');
        const onClick = this.props.onClick ?? this.onClose;
        return (
            this.state.isOpen && (
                <>
                    <div
                        className={`page-announcement ${this.props.announcement_bar_styles ?? ''}`}
                    >
                        <div className="page-announcement-header">
                            <div className="d-flex gap-10">
                                <img src="/static/img/megaphone.svg" alt="omg" />
                                {t('discover.announcement.header')}
                            </div>
                            <button onClick={this.onClose}>
                                <i className="icon-close" />
                            </button>
                        </div>
                        <div className="page-announcement-body">{this.props.message}</div>
                        <div className="page-announcement-footer">
                            {this.props.isLink ? (
                                <a
                                    className={`button button-filled button-primary ${
                                        this.props.buttonStyles ?? ''
                                    }`}
                                    href={this.props.href}
                                >
                                    {buttonName}
                                </a>
                            ) : (
                                <div>
                                    <button
                                        className={`button button-filled button-primary d-flex align-items-center gap-8 ${
                                            this.props.buttonStyles ?? ''
                                        }`}
                                        onClick={onClick}
                                        disabled={this.props.loading}
                                    >
                                        {this.props.loading && <Loading onlyPreloader />}
                                        {buttonName}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )
        );
    }
}
export default withTranslation()(Announcement);
